import React, { useState } from "react";

interface CollapsibleSectionProps {
	title: string;
	badge?: string;
	children: React.ReactNode;
}

export const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({ title, badge, children }) => {
	const [isOpen, setIsOpen] = useState(false);
	return (
		<div className="mb-4 border border-gray-200 rounded-lg bg-white shadow-sm">
			<button
				onClick={() => setIsOpen(!isOpen)}
				className="w-full flex items-center gap-2 px-4 py-3 text-gray-700 font-medium hover:text-gray-900 transition-colors"
			>
				<svg
					className={`w-4 h-4 transition-transform ${isOpen ? "rotate-90" : ""}`}
					fill="none"
					stroke="currentColor"
					viewBox="0 0 24 24"
				>
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
				</svg>
				{title}
				{badge && !isOpen && (
					<span className="ml-2 text-xs px-2 py-0.5 rounded-full bg-orange-100 text-orange-800 font-medium">
						{badge}
					</span>
				)}
			</button>
			{isOpen && <div className="px-4 pb-4">{children}</div>}
		</div>
	);
};
